exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-editable-date div {\n  position: relative;\n  text-transform: capitalize; }\n  app-editable-date div .mat-input-element {\n    visibility: collapse;\n    width: 0 !important;\n    height: 0 !important;\n    position: absolute; }\n  app-editable-date div .highlight > span {\n    position: relative;\n    width: -moz-fit-content;\n    width: fit-content;\n    border-bottom: 1px dotted;\n    padding-bottom: 4px;\n    height: 18px; }\n", ""]);

// exports
